import { useEffect, useState } from "react";
import { __ } from '@wordpress/i18n';

const WPResetPasswordForm = ({onClickLoginForm}) => {

  const [userLogin, setUserLogin  ] = useState('');
  const [alertMsg, setAlertMsg  ] = useState('');

  const handleClick = (e) => {
    e.preventDefault();
    onClickLoginForm(false);
  }

  const handleLostPasswordSubmit = async (e) => {
    e.preventDefault();

    setAlertMsg( 'Working....' );

      const formdata = new FormData();
      formdata.append("action", "hive_support_lost_password");
      formdata.append("nonce", hive_front.security );
      formdata.append("user_login", userLogin );
      
      const request = await fetch(hive_front.ajaxurl, {
        method: "POST",
        body: formdata,
      });

      const response = await request.json();
      setAlertMsg( response.data.msg );

  }

  return (
    <>
    <form onSubmit={handleLostPasswordSubmit} class="hs-lostpasswordform" name="lostpasswordform" id="lostpasswordform" action="#" method="post">
      <p>{__( "Please enter your username or email address. You will receive an email message with instructions on how to reset your password.", "hive-support" )}</p>
      <p>
          <label for="user_login">{ __( "Username or Email Address", "hive-support" ) }</label>
          <input type="text" name="user_login" onChange={(e) => setUserLogin(e.target.value)} id="user_login" required="required"/>
      </p>
      <input type="hidden" name="redirect_to"/>
      <p class="submit">
          <input type="submit" name="wp-submit" id="wp-submit" class="button button-primary button-large" value={ __( "Get New Password", "hive-support" ) } />
          <a onClick={handleClick} href="#">{ __( "Login", "hive-support" ) }</a>
      </p>
      <p dangerouslySetInnerHTML={{ __html: alertMsg }}></p>
    </form>
      
    </>
  );
};

export default WPResetPasswordForm;
